<script>
	import { updateToolbarOembed } from '../../stores/toolbar/UpdateToolbarOembed';

	const onSubmit = () => updateToolbarOembed(false);
</script>

<div class="proteus-control proteus-group protues-ui-input">
	<button class="proteus-button is-primary" on:click={onSubmit}>Submit</button>
</div>
